<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-container>
          <v-row justify="end" align="center" class="toolbar-row">
            <v-col cols="12" md="auto" class="d-flex align-center toolbar-action">
              <registrar-movimiento-dialog-component></registrar-movimiento-dialog-component>
            </v-col>
            <v-col cols="12" md="3" class="d-flex align-center toolbar-search">
              <v-text-field
                class="search-input"
                v-model="buscaMunicion"
                rounded
                filled
                dense
                hide-details
                background-color="transparent"
                color="secondary"
                label="Buscar por calibre"
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-data-table
                class="primary ui-module-table"
                :headers="headers"
                :items="municiones"
                :search="buscaMunicion"
                :items-per-page="-1"
                hide-default-footer
                calculate-widths
              >
                <template v-slot:[`item.opciones`]="{ item }">
                  <v-btn
                    rounded
                    small
                    color="secondary"
                    class="mx-2 ui-module-btn-solid ui-module-btn"
                    @click="openMovimientosDialog(item)"
                    >Ver movimientos</v-btn
                  >
                  <v-btn
                    rounded
                    small
                    color="secondary"
                    class="mx-2 ui-module-btn-solid ui-module-btn"
                    @click="openListaCargadoresDialog(item)"
                  >
                    Ver lista de cargadores</v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <historial-movimientos-dialog-component
      :active="historialMovimientosDialog"
      :calibre="selectedCalibre"
      @close="historialMovimientosDialog = false"
    ></historial-movimientos-dialog-component>
    <lista-cargadores-dialog-component
      :active="listaCargadoresDialog"
      @close="listaCargadoresDialog = false"
    ></lista-cargadores-dialog-component>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import HistorialMovimientosDialogComponent from '../../components/armeria/HistorialMovimientosDialogComponent.vue'
import ListaCargadoresDialogComponent from '../../components/armeria/ListaCargadoresDialogComponent.vue'
import RegistrarMovimientoDialogComponent from '../../components/armeria/RegistrarMovimientoDialogComponent.vue'

export default {
  components: {
    RegistrarMovimientoDialogComponent,
    HistorialMovimientosDialogComponent,
    ListaCargadoresDialogComponent,
  },

  data() {
    return {
      headers: [
        { text: 'Calibre', value: 'calibre', width: '10%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%' },
      ],

      buscaMunicion: '',

      historialMovimientosDialog: false,
      listaCargadoresDialog: false,

      movimientosCargador: [],
      movimientosMunicion: [],

      selectedCalibre: null,
    }
  },

  computed: {
    ...mapGetters('calibre', {
      calibres: 'getCalibres',
    }),

    ...mapGetters('movimientoMunicion', {
      movimientoMunicion: 'getMovimientoMunicion',
    }),

    municiones: function () {
      var municiones = []
      this.calibres.forEach((calibre) => {
        municiones.push({
          idCalibre: calibre.id,
          calibre: calibre.title,
          stock_municiones: this.getStockMunicionesByCalibre(calibre.id),
          stock_cargadores: 0,
        })
      })
      return municiones
    },
  },

  methods: {
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicion', 'fetchMovimientoMunicionDisponibles']),
    ...mapActions('movimientoCargador', ['fetchMovimientoCargador', 'fetchMovimientoCargadorDisponibles']),
    ...mapActions('cargadores', ['fetchCargadores']),

    async openMovimientosDialog(calibre) {
      this.selectedCalibre = calibre
      await this.fetchMovimientoCargador(calibre.idCalibre)
      await this.fetchMovimientoCargadorDisponibles(calibre.idCalibre)
      await this.fetchMovimientoMunicion()
      await this.fetchMovimientoMunicionDisponibles(calibre.idCalibre)

      this.historialMovimientosDialog = true
    },

    async openListaCargadoresDialog(calibre) {
      this.selectedCalibre = calibre
      await this.fetchCargadores(calibre.idCalibre)

      this.listaCargadoresDialog = true
    },

    getStockMunicionesByCalibre(id_calibre) {
      var stock = 0

      var filteredMuniciones = this.movimientoMunicion.filter((movimiento) => {
        return movimiento.fk_idCatCalibre == id_calibre
      })

      filteredMuniciones.forEach((movimiento) => {
        if (movimiento.fk_idcatTipoMovimiento == 1) {
          stock += movimiento.cantidad
        } else {
          stock -= movimiento.cantidad
        }
      })

      return stock
    },
  },
}
</script>

<style scoped>
.inventario-municiones-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(108, 92, 231, 0.2);
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px;
}

.toolbar-row {
  row-gap: 8px;
}

.toolbar-action,
.toolbar-search {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Input de búsqueda */
::v-deep .search-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .search-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input input {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Botones e iconos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-input__icon .v-icon {
  color: rgba(108, 92, 231, 0.7) !important;
}

::v-deep .v-input--is-focused .v-input__icon .v-icon {
  color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
